import React from 'react';

import { flagStyles } from '../settings';

const SvgBL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-576px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBL;
